module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "fixed": "",
      "text": "Checking token"
    }
  }), _vm._v(" "), (_vm.token.status === 'invalid') ? _c('div', {
    staticClass: "card-block"
  }, [_c('h2', [_vm._v("Token is expired or invalid")])]) : _c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    on: {
      "submit": _vm.resetPassword
    }
  }, [_c('h1', [_vm._v("Reset password")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Type your new password to reset it")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPass),
      expression: "newPass"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "New password"
    },
    domProps: {
      "value": (_vm.newPass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPass = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassConfirm),
      expression: "newPassConfirm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Confirm new password"
    },
    domProps: {
      "value": (_vm.newPassConfirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassConfirm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4 login-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("\n                    Reset\n                    "), (_vm.loading) ? _c('span', {
    staticClass: "btn-loader"
  }) : _vm._e()])])])])], 1)]), _vm._v(" "), (_vm.errors) ? _c('div', {
    staticClass: "card card-inverse card-danger"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Errors\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n            " + _vm._s(_vm.errors) + "\n          ")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f62ab19a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/unauthorizedPages/ResetPassword.vue
// module id = 1004
// module chunks = 0